<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="hotel-information content-wrapper">
      <div class="page-header">{{ $t('editInformation') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'HotelInfo' }">{{ $t('hotelInformation') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editInformation') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-container>
        <el-main>
          <el-form ref="form" label-width="150px">
            <el-form-item label="">
              <el-col :span="24">
                <div class="image-preview" v-if="imageData !== ''">
                  <img class="preview" width="150px" :src="imageData">
                </div>
                <div class="image-preview" v-if="this.hotel.logoUrl !== '' && imageData === ''">
                  <img class="preview" width="150px" :src="this.hotel.logoUrl">
                </div>
                <input-file-component v-model="fileData"
                                      :max-file-size="maxFileSize"
                                      accept="image/*"
                                      @onErrorOverLimitFileSize="onErrorOverLimitFileSize()">
                </input-file-component>
                <div>
                  <small class="text-remark">{{ $t('remarkImageSize') }}</small>
                </div>
              </el-col>
            </el-form-item>
            <el-form-item label="">
              <el-col :span="24">
                <el-radio v-model="hotel.isEnable" :label="1">{{ $t('STATUS.ENABLE') }}</el-radio>
                <el-radio v-model="hotel.isEnable" :label="0">{{ $t('STATUS.DISABLE') }}</el-radio>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('name')" :required="true">
              <el-col :span="24">
                <el-input type="text" v-model="hotel.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('code')" :required="true">
              <el-col :span="24">
                <el-input class="text-uppercase" type="text" v-model="hotel.code"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('address')">
              <el-col :span="24">
                <el-input type="textarea"
                          :rows="3"
                          v-model="hotel.address"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :key="`email-${index}`" v-for="(email, index) in hotel.information.emailList"
                          :label="bindLabel(index, $t('email'))">
              <el-col :span="12">
                <el-input v-model="hotel.information.emailList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2">
                <el-button type="danger" icon="el-icon-delete" circle
                           @click="onRemoveItemButtonClick('emailList', hotel.information.emailList[index], index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4">
                <el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('emailList')">
                  {{ $t('addEmail') }}
                </el-button>
              </el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item :key="`phone-${index}`" v-for="(phone, index) in hotel.information.phoneList"
                          :label="bindLabel(index, $t('tel'))">
              <el-col :span="12">
                <el-input v-model="hotel.information.phoneList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2">
                <el-button type="danger" icon="el-icon-delete" circle
                           @click="onRemoveItemButtonClick('phoneList', hotel.information.phoneList[index], index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="4">
                <el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('phoneList')">
                  {{ $t('addTel') }}
                </el-button>
              </el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item :key="`fax-${index}`" v-for="(fax, index) in hotel.information.faxList"
                          :label="bindLabel(index, $t('fax'))">
              <el-col :span="12">
                <el-input v-model="hotel.information.faxList[index]"></el-input>
              </el-col>
              <el-col v-if="index > 0" :span="2">
                <el-button type="danger" icon="el-icon-delete" circle
                           @click="onRemoveItemButtonClick('faxList', hotel.information.faxList[index], index)"></el-button>
              </el-col>
            </el-form-item>
            <el-form-item label="">
              <el-col :span="4">
                <el-button type="primary" size="mini" plain @click="onAddMoreItemButtonClick('faxList')">
                  {{ $t('addFax') }}
                </el-button>
              </el-col>
              <el-col :span="20"></el-col>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="onSaveHotelInfoButtonClick">{{ $t('saveChange') }}</el-button>
              <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/Information/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import HotelApi from '@/api/hotel-api'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'
import { map, trim, get, isEmpty } from 'lodash'
import InputFileComponent from '@/components/InputFileComponent'

export default {
  name: 'EditHotelInfo',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, InputFileComponent },
  i18n: { messages: i18nMessages },
  props: {
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    hotel: 'prepareData',
    fileData: function (newVal) {
      this.imageData = get(newVal, 'content', '')
    }
  },
  data () {
    return {
      isLoading: true,
      imageData: '',
      fileData: {},
      maxFileSize: 5767168,
      deletedHotelInformation: {
        emailList: [],
        phoneList: [],
        faxList: []
      }
    }
  },
  created: async function () {
    if (isEmpty(this.hotel)) {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }
    this.prepareInformation()
    this.isLoading = false
  },
  methods: {
    prepareData: function () {
      if (this.hotel.information.emailList.length === 0) {
        this.hotel.information.emailList.push('')
      }
    },
    prepareInformation: function () {
      for (const key in this.hotel.information) {
        if (this.hotel.information[key].length <= 0) {
          this.hotel.information[key].push('')
        }
      }
    },
    onAddMoreItemButtonClick: function (keyItem) {
      this.hotel.information[keyItem].push('')
    },
    onRemoveItemButtonClick: async function (keyItem, data, index) {
      this.hotel.information[keyItem].splice(index, 1)
    },
    bindLabel: function (index, defaultLabel) {
      return (index === 0) ? defaultLabel : ''
    },
    onSaveHotelInfoButtonClick: async function () {
      try {
        this.startLoading()

        let imageData = {}
        if (this.imageData !== '') {
          imageData = {
            imageData: this.imageData
          }
        }

        this.hotel.information.emailList = map(this.hotel.information.emailList, trim)
        this.hotel.information.phoneList = map(this.hotel.information.phoneList, trim)
        this.hotel.information.faxList = map(this.hotel.information.faxList, trim)
        this.hotel.code = this.hotel.code.toUpperCase()
        this.filterHotelInformation()
        const hotelData = Object.assign({}, this.hotel, imageData)
        await HotelApi.update(this.hotel.id, hotelData)
        const title = this.$t('saveHotelInfoSuccessTitle')
        const message = this.$t('saveHotelInfoSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
      this.$router.push({
        name: 'HotelInfo'
      })
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelInfo'
      })
    },
    filterHotelInformation: function () {
      for (const key in this.hotel.information) {
        if (Array.isArray(this.hotel.information[key])) {
          this.hotel.information[key] = this.hotel.information[key].filter(item => item !== '')
        }
      }
    },
    onErrorOverLimitFileSize: function () {
      this.alertError(this.$t('imageSizeOverMessage'))

      return false
    }
  }
}
</script>

<style scoped>
.text-remark {
  color: #F56C6C;
}
</style>
